"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var FolderOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M405.333 106.667H216.064c-41.13 0-63.04 4.224-85.867 16.426a120.192 120.192 0 00-49.749 49.771C68.224 195.691 64 217.6 64 258.731v506.538c0 41.131 4.224 63.04 16.427 85.867a120.192 120.192 0 0049.77 49.75c22.827 12.223 44.736 16.447 85.867 16.447h591.019c41.088 0 62.976-4.224 85.76-16.405 21.333-11.392 38.357-28.373 49.77-49.664 11.52-21.461 15.958-42.09 16.491-78.72l.747-409.835-.086-4.8a128 128 0 00-127.914-123.242H531.989l-93.866-112.64a42.667 42.667 0 00-32.79-15.36zM385.344 192l93.867 112.64A42.667 42.667 0 00512 320h319.85c23.574 0 42.667 19.093 42.667 42.773l-.704 407.659-.192 8.853-.341 7.382c-.683 10.069-2.005 15.872-4.245 20.949l-1.622 3.307a34.88 34.88 0 01-14.741 14.72c-4.95 2.645-9.813 4.33-18.176 5.29l-6.101.534-7.382.341-8.874.17H210.987l-8.875-.17-7.381-.341c-10.07-.64-15.872-1.984-20.971-4.203l-3.307-1.621a34.88 34.88 0 01-14.762-14.763l-1.622-3.307c-2.218-5.098-3.541-10.901-4.202-20.97l-.342-7.382-.192-8.874V253.653l.171-8.874.341-7.382c.64-10.069 1.984-15.872 4.203-20.97l1.621-3.307c3.456-6.485 8.278-11.307 14.763-14.763l3.307-1.621c5.098-2.219 10.901-3.541 20.97-4.203l7.382-.341 8.896-.192h174.357z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
FolderOutlined.displayName = "FolderOutlined";
var _default = exports["default"] = FolderOutlined;